export default "__VITE_ASSET__Cz8Wot1___"